<template>
    <b-tab :title="title" active>
        <template v-if="content == 'imageManager'">
            <image-manager />
        </template>

        <template v-if="content == 'videoManager'">
            <video-manager />
        </template>
    </b-tab>
</template>

<script>
import ImageManager from '../molecules/ImageManager.vue'
import VideoManager from '../molecules/VideoManager.vue'

export default {
  components: { ImageManager, VideoManager },
    name: "BTabItem",
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BTabItem.vue